import { useContext } from "react";
import { AppContext } from "../context/AppProvider";
import { RootStore } from "../stores/RootStore";

export const useStore = (): RootStore => useContext(AppContext).rootStore;

export default useStore;
